import { DateTime } from 'luxon'

import SATTestQ from '@/queries/SATTestQ'
import { useQuery } from '@/client/context/query'
import { SQL } from '@/client/query'

import type { SATTestsBoundary } from '../types'

export default function useSATBootcampTestsBoundary(): SATTestsBoundary {
  const query = useQuery()
  const minDate = query<string>`GREATEST(NOW(), MIN(${
    SATTestQ.series_start_date_min
  })) ${SATTestQ.where({}, SQL`${SATTestQ.series_end_date_max} >= NOW()`)}`
  const maxDate = query<string>`MAX(${SATTestQ.test_date}) ${SATTestQ.where({})}`

  return {
    minDate: minDate ?? DateTime.local().toISO(),
    maxDate: maxDate ?? DateTime.local().plus({ years: 1 }).toISO(),
  }
}
